import React, { useCallback, } from 'react';
import { connect, } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { isEmpty, } from 'ramda';

import Icon from 'common/components/Icon';
import SummarySellerTiles from './SellerTiles';
import SummaryPanelDataBox from './PanelDataBox';

type CommonContactDetails = {
    street: string,
    city: string,
};

type TaxPayerDetails = {
    name: string,
    nip: string,
};

type Props = Partial<{
    deliveryData: {
        firstName: string,
        lastName: string,
        name: string,
    } & CommonContactDetails,

    invoiceData: CommonContactDetails & TaxPayerDetails,
    payerData: CommonContactDetails & TaxPayerDetails & { email?: string, },
    diffPayer: boolean,
}>;

const SummaryBuyerPanel: React.FC<Props> = ({
    deliveryData,
    invoiceData,
    payerData,
    diffPayer,
}) => {
    const data = {
        delivery: {
            IconComponent: Icon.CardCar,
            header: 'Adres do wysyłki',
            content: [
                deliveryData?.name ?? '',
                `${deliveryData?.firstName} ${deliveryData?.lastName}`,
                deliveryData?.street ?? '',
                deliveryData?.city ?? '',
            ],
        },

        invoice: {
            IconComponent: Icon.CardPage,
            header: 'Dane na fakturze',
            content: [
                invoiceData?.name ?? '',
                invoiceData?.street ?? '',
                invoiceData?.city ?? '',
                invoiceData?.nip ?? '',
            ],
        },

        payer: {
            IconComponent: Icon.CardMoney,
            header: 'Dane płatnika',
            subheader: 'Wybrano inne dane, niż dane na fakturze.',
            content: [
                payerData?.name ?? '',
                payerData?.street ?? '',
                payerData?.city ?? '',
                payerData?.nip ?? '',
                payerData?.email ?? '',
            ]
        },
    };

    const payerHeader = useCallback(
        () => (
            <Box display="flex"
                 mt={2}
                 flexDirection={{ xs: 'column', lg: 'row', }}
                 alignItems={{ xs: 'baseline', lg: 'center', }}>
                <Box flexBasis="44%">
                    <Typography variant="h5">
                        <Box display="flex">
                            <Box mr={0}
                                 component={data.payer.IconComponent}/>
                            {data.payer.header}
                        </Box>
                    </Typography>
                </Box>
                {diffPayer && <Typography variant="caption">
                    ({data.payer.subheader})
                </Typography>}
            </Box>
        ),
        [ data.payer.IconComponent, data.payer.header, data.payer.subheader, diffPayer, ]
    );

    return (
        <SummarySellerTiles renderHeader="Kupujący">
            <Grid container
                  direction="row"
                  spacing={2}>
                <Grid item
                      md={6}
                      sm={12}
                      xs={12}>
                    <SummaryPanelDataBox content={data.delivery.content}
                                         IconComponent={data.delivery.IconComponent}
                                         header={data.delivery.header} />
                </Grid>
                <Grid item
                      md={6}
                      sm={12}
                      xs={12}>
                    <SummaryPanelDataBox content={data.invoice.content}
                                         IconComponent={data.invoice.IconComponent}
                                         header={data.invoice.header} />
                    {!isEmpty(payerData) && <SummaryPanelDataBox content={data.payer.content}
                                         IconComponent={data.payer.IconComponent}
                                         header={payerHeader} />}
                </Grid>
            </Grid>
        </SummarySellerTiles>
    );
};

type MappingType = {
    checkout: {
        values: any,
    }
};

const mapStateToProps = ({ checkout, }: MappingType) => {
    const shippingAddress = checkout.values?.shippingAddress;
    const billingAddress = checkout.values?.billingAddress;
    const payerAddress = checkout.values?.payerAddress;
    const diffPayer = Boolean(checkout.values?.differentData);

    return {
        deliveryData: {
            name: shippingAddress?.company,
            firstName: shippingAddress?.firstName,
            lastName: shippingAddress?.lastName,
            street: `${shippingAddress?.street} ${shippingAddress?.streetNumber}`,
            city: `${shippingAddress?.postcode} ${shippingAddress?.city}`,
        },

        invoiceData: {
            name: billingAddress?.company,
            street: `${billingAddress?.street} ${billingAddress?.streetNumber}`,
            city: `${billingAddress?.postcode} ${billingAddress?.city}`,
            nip: billingAddress?.taxIdNumber,
        },

        payerData: {
            name: payerAddress?.company,
            street: `${payerAddress?.street} ${payerAddress?.streetNumber}`,
            city: `${payerAddress?.postcode} ${payerAddress?.city}`,
            nip: payerAddress?.taxIdNumber,
            email: payerAddress.schoolEmail,
        },
        diffPayer,
    };
};

export default connect(
    mapStateToProps,
)(SummaryBuyerPanel);